import { render, staticRenderFns } from "./passport.vue?vue&type=template&id=79721fcf&scoped=true&"
import script from "./passport.vue?vue&type=script&lang=js&"
export * from "./passport.vue?vue&type=script&lang=js&"
import style0 from "./passport.vue?vue&type=style&index=0&id=79721fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79721fcf",
  null
  
)

export default component.exports